export default __webpack_public_path__ + "static/media/Boton_2.718a8566.png";